import { render, staticRenderFns } from "./intellectual.vue?vue&type=template&id=2c74507d&scoped=true"
import script from "./intellectual.vue?vue&type=script&lang=js"
export * from "./intellectual.vue?vue&type=script&lang=js"
import style0 from "./intellectual.vue?vue&type=style&index=0&id=2c74507d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c74507d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\git-new\\ai-business-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c74507d')) {
      api.createRecord('2c74507d', component.options)
    } else {
      api.reload('2c74507d', component.options)
    }
    module.hot.accept("./intellectual.vue?vue&type=template&id=2c74507d&scoped=true", function () {
      api.rerender('2c74507d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clue/components/intellectual.vue"
export default component.exports